import ClearingAPI from '@shared/api';

export const {
    schedule: { start: postStart, setCompleted: postSetCompleted },
    manualApprove: { isWaiting: getIsWaiting, approve: postManualApprove },
} = ClearingAPI.settings;
